import { certificationColors } from '../lib/certifications';

/** The list card's chip and the profile's are the same chip at two sizes. */
type ChipSize = 'card' | 'profile';

const PADDING: Record<ChipSize, string> = {
  card: 'px-2.5 py-1',
  profile: 'px-3 py-1.5',
};

/** The attendee's category (DIR-01): neutral, because no palette names one per category. */
export function CategoryChip({ label, size = 'card' }: { label: string; size?: ChipSize }) {
  return (
    <span className={`text-chip rounded-full bg-sand-2 font-semibold text-ink-2 ${PADDING[size]}`}>
      {label}
    </span>
  );
}

/**
 * What procurement officers look for first (DIR-02), in the kit's own colour pairs. The colour is
 * derived from the label rather than stored, so this is the one place that decision lives.
 */
export function CertificationChip({ label, size = 'card' }: { label: string; size?: ChipSize }) {
  const colors = certificationColors(label);

  return (
    <span
      className={`text-chip rounded-full font-semibold ${PADDING[size]}`}
      style={{ backgroundColor: colors.bg, color: colors.text }}
    >
      {label}
    </span>
  );
}
